import { IFunctionComponent } from '@omaze/app';
import { COLLAPSE_SIZES, COLLAPSE_STYLES, OzCollapse } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { prizeDetailsFeatureNamespace } from '../../../PrizeDetailsFeature.namespace';

import { displayName, PRIZE_DETAILS_QA } from './PrizeDetails.qa';
import { IPrizeDetailsClassNames, PrizeDetailsPresenter } from './PrizeDetailsPresenter/PrizeDetailsPresenter';

export interface IPrizeDetailsProps {
    prizeDetails: string;
}

export const PrizeDetails: IFunctionComponent<IPrizeDetailsProps> = prizeDetailsFeatureNamespace.createComponent(
    displayName,
    (props: IPrizeDetailsProps): ReactElement => {
        const { prizeDetails }: IPrizeDetailsProps = props;
        const presenter: PrizeDetailsPresenter = new PrizeDetailsPresenter();
        const classNames: IPrizeDetailsClassNames = presenter.getAllClassNames();

        return (
            <div data-testid={PRIZE_DETAILS_QA.CONTAINER} className={classNames.prizeDetailsContainer}>
                <OzCollapse
                    buttonClassName='m-auto'
                    className={classNames.prizeDetailsCollapse}
                    size={COLLAPSE_SIZES.SMALL}
                    style={COLLAPSE_STYLES.TEXT}
                >
                    <OzCollapse.Title>
                        <span className={classNames.title} data-testid={PRIZE_DETAILS_QA.BUTTON_TEXT}>Prize details</span>
                    </OzCollapse.Title>
                    <OzCollapse.Content>
                        <div
                            className={classNames.prizeDetailsListContainer}
                            data-testid={PRIZE_DETAILS_QA.CONTENT}
                            dangerouslySetInnerHTML={{ __html: prizeDetails }}
                        />
                    </OzCollapse.Content>
                </OzCollapse>
            </div>
        );
    }
);
